<template>
  <!-- 广告列表 -->
  <div>
    <!-- 筛选查询 -->
    <div class="wScreenArea">
      <el-card class="box-card">
        <div class="wScreenCardHeader">
          <span></span>
          <el-button
            type="primary"
            size="mini"
            @click="wFun_openBannerFrame()"
          >添加</el-button>
        </div>
      </el-card>
    </div>
    <!-- 表格数据 -->
    <div class="wTableArea">
      <!-- 订单列表 -->
      <template>
        <!-- 表格 -->
        <el-table
          border
          :data="wTable.wList"
        >
          <el-table-column
            prop="id"
            label="编号"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            label="轮播图片"
            align="center"
          >
            <template slot-scope="scope">
              <el-image
                style="width: 180px; height: 100px"
                fit="cover"
                :src="scope.row.imgUrl"
                :preview-src-list="[scope.row.imgUrl]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="isUsed"
            label="状态"
            align="center"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.isUsed == 0">禁用</div>
              <div v-else-if="scope.row.isUsed == 1">启用</div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="wFun_openBannerFrame(scope)"
              ><span>编辑</span></el-button>
              <el-button
                type="text"
                @click="wFun_deleteBannerById(scope.row.id)"
              ><span>删除</span></el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <!-- 分页 -->
      <div
        class="wPagination"
        v-if="false"
      >
        <el-pagination
          background
          :layout="wC_layout"
          :current-page="wTable.wPage"
          :page-size="wTable.wLimit"
          :total="wTable.wTotal"
          :page-sizes="wC_pageSizes"
          :hide-on-single-page="false"
          @current-change="wELPageCurrentChange"
          @size-change="wELPageSizeChange"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 新增、修改版banner弹框 -->
    <el-dialog
      :title="wBanner.wForm.wId ? '修改轮播' : '添加轮播'"
      :visible.sync="wBanner.wIsShow"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <!-- 表单 -->
      <el-form
        ref="wBannerForm"
        :model="wBanner.wForm"
        label-width="120px"
        @submit.native.prevent
      >
        <el-form-item
          label="上传图片："
          prop="wImage"
          required
        >
          <el-upload
            class="avatar-uploader"
            :action="wFun_getUploadImgPath()"
            :show-file-list="false"
            :before-upload="wFun_beforeUpload_banner"
            :on-success="wFun_success_banner"
            :on-error="wFun_error_banner"
          >
            <el-image
              class="avatar"
              v-if="wBanner.wForm.wImage"
              :src="wBanner.wForm.wImage"
              fit="contain"
            ></el-image>
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon"
            ></i>
          </el-upload>
        </el-form-item>
        <el-form-item prop="aaa" style="width:300px;margin-right: 10px;" label="选择广告位：">
            <el-select v-model="wBanner.wForm.wLocation">
                <el-option  label="满减免单" value="500">
                </el-option>
                <el-option  label="会员专享" value="501">
                </el-option>
                <el-option  label="会员面单" value="502">
                </el-option>
            </el-select>    
        </el-form-item>
        <el-form-item
          label="是否启用："
          prop="wIsUsed"
        >
          <el-switch
            v-model="wBanner.wForm.wIsUsed"
            active-text="启用"
            inactive-text="禁用"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <!-- footer -->
      <div slot="footer">
        <el-button @click="wBanner.wIsShow = false">取 消</el-button>
        <el-button
          type="primary"
          @click="wFun_submitBannerInfo"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getOperateBannerListApi,
  addOperateBannerApi,
  editOperateBannerApi,
  deleteOperateBannerApi,
} from "@/network/api";

export default {
  name: "OperateBanner",
  data() {
    return {
      // 字典数据
      wDic_location: [],
      wDic_jumpType: [],
      // 筛选查询
      wScreen: {
        wLocation: null // 广告位
      },
      // 表格数据
      wTable: {
        wPage: 1,
        wLimit: 10,
        wTotal: 0,
        wList: []
      },
      // 添加/修改banner弹框
      wBanner: {
        wIsShow: false, // 是否展示
        wForm: {
          wId: null, // id 有值代表
          wLocation: null, // 广告位
          wJumpType: "0", // 跳转类型
          wImage: null, // 图片
          wIsUsed: true // 禁止使用
        } // 表单数据
      }
    };
  },
  mounted() {
    this.wFun_queryTableData(true);
  },
  computed: {
    // 获取分页配置数据
    wC_layout() {
      return this.$store.state.wPage.wLayout;
    },
    wC_pageSizes() {
      return this.$store.state.wPage.wPageSizes;
    },
    // 获取广告位数据
    wC_location() {
      let [{ wDic_location }, wLocationArr] = [this, []];
      wDic_location.forEach(item => {
        let obj = {};
        obj.label = item.label;
        obj.value = item.value.toString();
        wLocationArr.push(obj);
      });
      return wLocationArr;
    },
    // 获取广告位跳转类型的数据
    wC_jumpType() {
      let [{ wDic_jumpType }, wJumpTypeArr] = [this, []];
      wDic_jumpType.forEach(item => {
        let obj = {};
        obj.label = item.label;
        obj.value = item.value.toString();
        wJumpTypeArr.push(obj);
      });
      return wJumpTypeArr;
    }
  },
  methods: {
    /**
     * wFun_getUploadImgPath
     * 方法-获取图片上传的地址
     */
    wFun_getUploadImgPath() {
      return `${process.env.VUE_APP_URE}/file/uploadFile`;
    },
    /**
     * wFun_beforeUpload_banner
     * 方法-上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传。
     */
    wFun_beforeUpload_banner(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isGIF = file.type === "image/gif";
      // const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isJPG && !isPNG && !isGIF) {
        this.$message.error("上传图片只能是 JPG 、 PNG 、 GIF 格式!");
      }
      // if (!isLt10M) {
      //   this.$message.error("上传图片大小不能超过 10MB!");
      // }
      // return (isJPG || isPNG) && isLt10M;
      return isJPG || isPNG || isGIF;
    },
    /**
     * wFun_success_banner
     * 方法-文件上传成功时的钩子
     */
    wFun_success_banner(response, file, fileList) {
      let [{ code: wCode, data: wData }] = [response, file, fileList];
      if (wCode == 200) {
        this.wBanner.wForm.wImage = wData;
      } else {
        this.$message.error("图片上传失败!");
      }
    },
    /**
     * wFun_error_banner
     * 方法-文件上传失败时的钩子
     */
    wFun_error_banner(err, file, fileList) {
      this.$message.error("图片上传失败!");
    },
    /**
     * wFun_formScreenSubmit
     * 方法-提交表单数据
     */
    wFun_formScreenSubmit() {
      // 方法-查询表格数据
      this.wFun_queryTableData(true);
    },
    /**
     * wELPageCurrentChange
     * 分页 currentPage 改变时会触发
     */
    wELPageCurrentChange(wP_cPage) {
      this.wTable.wPage = wP_cPage;
      this.$nextTick(() => {
        // 方法-查询表格数据
        this.wFun_queryTableData();
      });
    },
    /**
     * wELPageSizeChange
     * 修改分页条数
     * 分页 pageSize 改变时会触发 - 每页条数
     */
    wELPageSizeChange(wP_cPageSize) {
      this.wTable.wLimit = wP_cPageSize;
      this.$nextTick(() => {
        // 方法-查询表格数据
        this.wFun_queryTableData(true);
      });
    },
    /**
     * wFun_queryTableData
     * 方法-查询表格数据
     * @param wP_truthy 真值,true-初始值,false-加载更多
     */
    wFun_queryTableData(wP_truthy) {
      let [
        wData,
        {
          wScreen: { wLocation },
          wTable: { wPage, wLimit, wTotal, wList }
        }
      ] = [{}, this];
      // 广告位
      // if (wLocation) {
      //   wData.location = wLocation;
      // }
      wData.location = 111;
      // 请求函数
      getOperateBannerListApi(wData)
        .then(res => {
          // 更新数据
          this.wTable.wList = res;
        })
        .catch(err => {});
    },
    /**
     * wFun_deleteBannerById
     * 方法-根据id删除banner
     * @wP_id banner的id
     */
    wFun_deleteBannerById(wP_id) {
      if (!wP_id) {
        this.$message.error("系统繁忙，请稍后再试！");
        return;
      }
      this.$confirm("此操作将永久删除该轮播, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteOperateBannerApi({
            id: wP_id
          })
          .then(res => {
            this.$message.success("删除成功!");
            this.wFun_queryTableData();
          })
          .catch(err => {});
        })
        .catch(() => {});
    },
    /**
     * wFun_openBannerFrame
     * 方法-打开banner弹框
     * @param wP_obj banner信息
     */
    wFun_openBannerFrame(wP_obj) {
      // 打开弹框
      this.wBanner.wIsShow = true;
      this.$nextTick(() => {
        // 表单初始化
        this.$refs["wBannerForm"].resetFields();
        this.wBanner.wForm.wId = null;
        if (wP_obj) {
          // 修改banner，给表单赋值
          let [
            {
              row: {
                id: wId,
                location: wLocation,
                jumpType: wJumpType,
                bannerParams, // 根据跳转类型来，暂时还未开发！
                imgUrl: wImage,
                isUsed: wIsUsed // 是否有效 0-无效 1-有效
              }
            }
          ] = [wP_obj];
          // 更新数据
          this.wBanner.wForm.wId = wId;
          this.wBanner.wForm.wLocation = wLocation.toString();
          this.wBanner.wForm.wJumpType = wJumpType.toString();
          this.wBanner.wForm.wImage = wImage;
          this.wBanner.wForm.wIsUsed = wIsUsed == 1;
        }
      });
    },
    /**
     * wchange_location
     * 选中值发生变化时触发
     */
    wchange_location(wP_value) {
    },
    /**
     * wchange_jumpType
     * 选中值发生变化时触发
     */
    wchange_jumpType(wP_value) {
      switch (wP_value.toString()) {
        default:
          break;
      }
    },
    /**
     * wFun_submitBannerInfo
     * 方法-提交banner信息
     */
    wFun_submitBannerInfo() {
      let [
        wData,
        {
          wBanner: { wForm }
        }
      ] = [{}, this];

      //id: wId,
      //location: wLocation,
      //jumpType: wJumpType,
      //bannerParams, // 根据跳转类型来，暂时还未开发！
      //imgUrl: wImage,
      //isUsed: wIsUsed, // 是否有效 0-无效 1-有效

      // 条件判断
      // 广告位
      if (!wForm.wLocation) {
        this.$message.warning("请选择广告位!");
        return false;
      }
      wData.location = wForm.wLocation;
      // 跳转类型
      if (!wForm.wJumpType) {
        this.$message.warning("请选择跳转类型!");
        return false;
      }
      wData.jumpType = wForm.wJumpType;
      // banner图片
      if (!wForm.wImage) {
        this.$message.warning("请选择轮播图片!");
        return false;
      }
      wData.imgUrl = wForm.wImage;
      // 是否有效 0-无效 1-有效
      wData.isUsed = wForm.wIsUsed ? 1 : 0;

      // 根据id是否存在判断新增或修改
      if (wForm.wId) {
        // 修改
        // banner id
        wData.id = wForm.wId;

        editOperateBannerApi(wData)
          .then(res => {
            this.$message.success("修改成功!");
            // 更新数据
            this.wBanner.wIsShow = false;
            this.wFun_queryTableData();
          })
          .catch(err => {});
      } else {
        // 新增
        addOperateBannerApi(wData)
          .then(res => {
            this.$message.success("添加成功!");
            // 更新数据
            this.wBanner.wIsShow = false;
            this.wFun_queryTableData();
          })
          .catch(err => {});
      }
    }
  }
};
</script>

<style lang="less">
@import "@/assets/css/publicStyle.less";
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #ff6321;
}
.avatar-uploader .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>